var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4L15.4 7.9V15.7C15.4 16.0448 15.263 16.3754 15.0192 16.6192C14.7754 16.863 14.4448 17 14.1 17H6.3C5.95522 17 5.62456 16.863 5.38076 16.6192C5.13696 16.3754 5 16.0448 5 15.7V5.3C5 4.95522 5.13696 4.62456 5.38076 4.38076C5.62456 4.13696 5.95522 4 6.3 4H11.5ZM14.1 15.7V8.55H10.85V5.3H6.3V15.7H14.1ZM9.875 9.2C11.5 9.2 12.8 10.5 12.8 12.125C12.8 13.75 11.5 15.05 9.875 15.05C8.25 15.05 6.95 13.75 6.95 12.125C6.95 10.5 8.25 9.2 9.875 9.2ZM9.875 10.175C9.511 10.175 9.173 10.2725 8.9 10.448L11.552 13.1C11.7275 12.827 11.825 12.489 11.825 12.125C11.825 11.6078 11.6196 11.1118 11.2539 10.7461C10.8882 10.3804 10.3922 10.175 9.875 10.175ZM7.925 12.125C7.925 12.6422 8.13045 13.1382 8.49614 13.5039C8.86184 13.8696 9.35783 14.075 9.875 14.075C10.239 14.075 10.577 13.9775 10.85 13.802L8.198 11.15C8.0225 11.423 7.925 11.761 7.925 12.125Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelar);
export default __webpack_public_path__ + "static/media/Cancelar.afccedd66bc75625f3c32644de558b50.svg";
export { ForwardRef as ReactComponent };